import { useEffect, useState } from 'react';

export const TOUR_MOBILE_MEDIA_QUERY = '(max-width: 47.99rem)';

function readMediaQuery(query: string, fallback = false) {
  return typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : fallback;
}

export function useTourViewport() {
  const [isMobile, setIsMobile] = useState(() =>
    readMediaQuery(TOUR_MOBILE_MEDIA_QUERY),
  );
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() =>
    readMediaQuery('(prefers-reduced-motion: reduce)'),
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mobileQuery = window.matchMedia(TOUR_MOBILE_MEDIA_QUERY);
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const handleMobileChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };
    const handleMotionChange = (event: MediaQueryListEvent) => {
      setPrefersReducedMotion(event.matches);
    };

    setIsMobile(mobileQuery.matches);
    setPrefersReducedMotion(motionQuery.matches);

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleMobileChange);
      motionQuery.addEventListener('change', handleMotionChange);

      return () => {
        mobileQuery.removeEventListener('change', handleMobileChange);
        motionQuery.removeEventListener('change', handleMotionChange);
      };
    }

    mobileQuery.addListener(handleMobileChange);
    motionQuery.addListener(handleMotionChange);

    return () => {
      mobileQuery.removeListener(handleMobileChange);
      motionQuery.removeListener(handleMotionChange);
    };
  }, []);

  return { isMobile, prefersReducedMotion };
}
